/**
 * Represents the version information of the application.
 * @implements {Version}
 */
export class Version {
  /**
   * The version of the project.
   */
  static projectVersion: string;
  /**
   * The version of the core library project is build upon.
   */
  static coreVersion: string;
  /**
   * The build number of the project. Usually, it is an id of pipeline that build the project.
   */
  static buildNumber: string;
  /**
   * Human-readable version of the application. It is a combination of project version, core version and build number.
   */
  static displayVersion: string;
  /**
   * The hash of the build, which is a combination of project version, core version and build number.
   */
  static buildHash: string;

  /**
   * Initializes the Version class.
   */
  static initialize(): void {
    const rootDataSet = document.getElementById('root')?.dataset;

    if (!rootDataSet) {
      console.warn('Root dataset is not found!');
    }

    this.projectVersion = rootDataSet?.gameVersion ?? '';
    this.coreVersion = rootDataSet?.coreVersion ?? '';
    this.buildNumber = rootDataSet?.buildNumber ?? '';
    this.displayVersion = this.getDisplayVersion();
    this.buildHash = this.getBuildHash();

    if (rootDataSet?.localCore === 'true') {
      console.warn('%cLOCAL CORE VERSION IS USED!', 'font-size: 40px;');
    }
    // console.log(`Application version: ${this.displayVersion}`);
  }

  /**
   * Generates the build hash.
   * @private
   * @returns {string} The build hash.
   */
  private static getBuildHash(): string {
    return `${this.projectVersion}-${this.coreVersion}-${this.buildNumber}`;
  }

  /**
   * Generates the complete version string.
   * @private
   * @returns {string} The complete version string.
   */
  private static getDisplayVersion(): string {
    if (!this.coreVersion || !this.projectVersion || !this.buildNumber) {
      return '';
    }
    return `${this.projectVersion} (${this.coreVersion}) ${this.buildNumber}`;
  }
}

// Initialize the Version class
Version.initialize();
